// import components
import { ListSubheader, styled } from '@mui/material';

export const StyledTaskListHeader = styled(ListSubheader)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  backgroundColor: 'transparent',
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(6),
  marginBottom: theme.spacing(2)
}));
